import { config } from '@vici/vellapps-ds';

export default config;
